import { useEmailSenderApi } from "../../../../services/api/Senders";
import { useMemo } from "react";
import { IconButton, Select, Stack, Title } from "@introist/react-foundation/v2";
import { TagSelector } from "../../../system/tags/TagSelector";
import { SelectorIcon } from "../../../employees/fields/EmployeeFieldSelector";
import { isUuid } from "../../../../utils/string-templater";

export const MeetingHostSelect = ({
  value,
  onChange
}: {
  value?: string;
  onChange: (value: string | null) => void;
}) => {
  const emailSenderApi = useEmailSenderApi();
  const { data: hosts } = emailSenderApi.list({ filterEmailOnlySenders: true }, {}).query;

  const hostOptions = useMemo(() => {
    return (hosts ?? []).map(host => ({
      key: host.id,
      title: host.name,
      description: host.email
    }));
  }, [hosts]);

  return (
    <Stack>
      {(!value || isUuid(value)) && (
        <Select
          element="button"
          size="small"
          variant="blended"
          startAdornment={<SelectorIcon icon="person" />}
          placeholder="Account"
          options={hostOptions}
          value={value}
          onSelect={opt => onChange(opt.key)}
          attachToRef={false}
          searchable
        />
      )}
      {!value && <Title>or</Title>}
      {(!value || !isUuid(value)) && (
        <TagSelector
          variant="blended"
          size="small"
          onSelect={tag => {
            onChange(`{{${tag.tag}}}`);
          }}
          value={value}
          title={!value ? "Dynamic" : undefined}
          ctx={{
            fieldTypes: ["email"]
          }}
        />
      )}
      {value && (
        <IconButton
          style={{ marginLeft: "auto" }}
          icon="crossSmall"
          onClick={() => onChange(null)}
        />
      )}
    </Stack>
  );
};
